module.exports = __webpack_public_path__ + "img/xdating.2062d08.png";